import React from "react";

import RecentMessages from "components/app/home/sections/teachers/RecentMessages";
import RecentNotices from "components/app/home/sections/teachers/RecentNotices";

import "./TeachersHomeSection.css";

/**
 * Delegate to each of the sections for the T2P product
 */
export default class TeachersHomeSection extends React.Component {
  
  render() {
    return (
      <div className="teachers-home">
        <RecentMessages />
        <RecentNotices />
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/app/home/sections/teachers/TeachersHomeSection.js